import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import translationENG from "./common/locales/en.json";

interface Translation {
  key: string;
  value: string;
}

// Local translations
const resources = {
  en: {
    translation: translationENG,
  },
};

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: sessionStorage.getItem("I18N_LANGUAGE") || "en-US",
    fallbackLng: sessionStorage.getItem("I18N_LANGUAGE") || "en-US",
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });

export const updateTranslationsAfterAPI = (
  apiData: Translation[],
  Culture: string
): boolean => {
  try {
    i18n.changeLanguage(Culture);
    i18n.addResourceBundle(Culture, "translation", apiData, true, true);
    return true;
  } catch (error: any) {
    console.error("Error while updating translations:", error.message);
    return false;
  }
};

export default i18n;
